define('views/pages/packs',['require','jquery','mediator','views/base/page','views/base/view','views/base/collection','text!templates/pages/packs/index.ejs','text!templates/pages/packs/item.ejs','text!templates/pages/packs/summary.ejs','text!templates/pages/packs/navbar.ejs','models/modals/claim/index','views/modals/claim/index','views/filter/index','lib/utils','views/filter-list','views/demo-dialog'],function(require) {
    'use strict';

    var $ = require('jquery'),
        mediator = require('mediator'),
        PageView = require('views/base/page'),
        View = require('views/base/view'),
        CollectionView = require('views/base/collection'),
        template = require('text!templates/pages/packs/index.ejs'),
        templateItem = require('text!templates/pages/packs/item.ejs'),
        templateSummary = require('text!templates/pages/packs/summary.ejs'),
        templateNavbar = require('text!templates/pages/packs/navbar.ejs'),
        ClaimModalModel = require('models/modals/claim/index'),
        ClaimModalView = require('views/modals/claim/index'),
        FilterView = require('views/filter/index'),
        utils = require('lib/utils'),
        FilterListView = require('views/filter-list'),
        DemoDialog = require('views/demo-dialog');

    var PacksRowView = View.extend({
        template: templateItem,
        className: 'packs-table-row',
        tagName: 'tr',
        events: {
            // 'click': 'clickRow'
        },
        listen: {
            'change:selected model': 'render',
            'change:viewPrice model': 'render'
        },
        clickRow: function(ev) {
            if ($(ev.target).is('a')) { return 0; }

            var item = this.model.collection.findWhere({ selected: true });
            if (item && item !== this.model) {
                item.set('selected', false);
            }
            this.model.set('selected', !this.model.get('selected'));
        },
        render: function() {
            View.prototype.render.apply(this, arguments);
            if (this.model.get('selected')) {
                this.$el.addClass('active');
            } else {
                this.$el.removeClass('active');
            }
        }
    });

    var PacksTableView = CollectionView.extend({
        itemView: PacksRowView,
        autoRender: true,
        className: 'packs-table',
        tagName: 'tbody',
        region: 'packs-table',
        listen: {
            'filterChanged model': 'render'
        }
    });

    var PacksSummaryView = View.extend({
        region: 'packs-summary',
        autoRender: true,
        template: templateSummary,
        listen: {
            'filterChanged model': 'render'
        }
    });

    var PacksNavbarView = View.extend({
        region: 'packs-navbar',
        className: 'navbar-inner',
        autoRender: true,
        template: templateNavbar,
        regions: {
            'navbar': '.navbar-form'
        },
        events: {
            'click #makeClaim': 'onCreateClaimClick',
            'click #pricePercent': 'onPricePercentClick'
        },
        listen: {
            'change:pricePercent model': 'activatePricePercent'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
        },
        render: function() {
            View.prototype.render.apply(this, arguments);
            this.subview('filter-list', new FilterListView({ model: this.model.filterList }));
        },
        onCreateClaimClick: function() {
            var model = this.model;

            var modalModel = new ClaimModalModel({});
            var content = modalModel.content;

            this.subview('claim', new ClaimModalView({ model: modalModel }));
            modalModel.on('action', function(action, cancel) {

                if (action==='submit') {
                    if (DemoDialog.isDemo()) { cancel(); return DemoDialog.show(); }

                    var valid = (content.get('type') > -1) &&
                        content.get('currencyId') &&
                        content.get('cost') &&
                        content.get('description') &&
                        content.goods.length;
                    console.log(content.getAttributes(), valid);
                    if (!valid) {
                        cancel();
                    } else {
                        content.set('items', content.goods.pluck('dealId'));
                        content.save();
                    }

                }
            });

            content.set('tradeId', model.get('tradeId'));
            content.load();
        },
        onPricePercentClick: function() {
            this.model.set('pricePercent', !this.model.get('pricePercent'));
        },
        activatePricePercent: function() {
            // if (this.model.get('pricePercent')) {
            //     $('#pricePercent').addClass('active');
            // } else {
            //     $('#pricePercent').removeClass('active');
            // }
            this.render();
        }
    });

    var PacksPageView = PageView.extend({
        id: 'packs-page',
        autoRender: true,
        template: template,
        regions: {
            'packs-table': '#packs-table',
            'packs-summary': '#packs-summary',
            'packs-navbar': '#packs-navbar',
            'packs-filter': '#packs-filter'
        },
        listen: {
            'change:loading model': 'render'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
        },
        render: function() {
            PageView.prototype.render.apply(this, arguments);

            this.subview('table', new PacksTableView({ collection: this.model.items, model: this.model }));
            this.subview('summary', new PacksSummaryView({ model: this.model }));
            this.subview('navbar', new PacksNavbarView({ model: this.model }));
            this.subview('filter', new FilterView({ model: this.model.filter, region: 'packs-filter' }));

            var trade = this.model.get('trade');
            if (trade) {
                mediator.setBreadcrumbTail(trade);
            }
        },
        inViewCurrencyClick: function(ev) {
            if (ev) {
                ev.stopPropagation();
                ev.preventDefault();
            }
            this.model.set('inViewCurrency', !this.model.get('inViewCurrency'));
            this.updateURL();
            this.model.load();
        },
        updateURL: function() {
            utils.changeURL('packs#show', {
                tradeId: this.model.get('tradeId'),
                currency: this.model.get('inViewCurrency') ? 'view' : 'base'
            });
        }
    });

    return PacksPageView;
});

